import dayjs from "dayjs";

/**
 * `dayjs` and `Date` in request payloads stringify to ISO UTC, shifting local
 * times (e.g. UTC+3) when the backend stores wall-clock datetimes. Format as
 * local calendar time instead, matching how manual fixes were done in forms.
 */
const API_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

const shouldRecurse = (v) => {
  if (v == null || typeof v !== "object") return false;
  if (Array.isArray(v)) return true;
  if (typeof File !== "undefined" && v instanceof File) return false;
  if (typeof Blob !== "undefined" && v instanceof Blob) return false;
  if (typeof FormData !== "undefined" && v instanceof FormData) return false;
  if (v instanceof ArrayBuffer) return false;
  if (ArrayBuffer.isView && ArrayBuffer.isView(v)) return false;
  if (v instanceof RegExp) return false;
  if (typeof Map !== "undefined" && v instanceof Map) return false;
  if (typeof Set !== "undefined" && v instanceof Set) return false;
  return true;
};

function walk(value) {
  if (value == null) return value;
  if (dayjs.isDayjs(value)) {
    return value.format(API_DATETIME_FORMAT);
  }
  if (value instanceof Date) {
    return dayjs(value).format(API_DATETIME_FORMAT);
  }
  if (typeof value !== "object") return value;
  if (Array.isArray(value)) {
    return value.map((item) => walk(item));
  }
  if (!shouldRecurse(value)) {
    return value;
  }
  const out = {};
  for (const key of Object.keys(value)) {
    out[key] = walk(value[key]);
  }
  return out;
}

/**
 * Immutable deep transform for JSON `data` / `params` objects before
 * `JSON.stringify` (Axios) runs.
 */
export function deepSerializeDatesForApi(value) {
  if (value == null) return value;
  if (typeof value !== "object") return value;
  return walk(value);
}

export function shouldSerializeDataAsJson(data) {
  if (data == null || typeof data !== "object") return false;
  if (data instanceof FormData) return false;
  if (data instanceof Blob) return false;
  if (typeof URLSearchParams !== "undefined" && data instanceof URLSearchParams) {
    return false;
  }
  return true;
}

export function shouldSerializeParamsObject(params) {
  if (params == null || typeof params !== "object") return false;
  if (typeof URLSearchParams !== "undefined" && params instanceof URLSearchParams) {
    return false;
  }
  return true;
}
